/**
 * ResourceLoadingChart — stacked bar of monthly resource demand by discipline.
 * Consumes `resourceDemand` array from scenario results.
 */
import React from 'react';
import {
  ResponsiveContainer, BarChart, XAxis, YAxis, CartesianGrid,
  Tooltip, Legend, Bar,
} from 'recharts';

const ResourceLoadingChart = ({ data = [] }) => (
  <div className="w-full h-72" data-testid="resource-loading-chart">
    <ResponsiveContainer>
      <BarChart data={data} margin={{ top: 10, right: 20, bottom: 10, left: 10 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#1F2937" />
        <XAxis dataKey="calendarMonth" stroke="#94A3B8" fontSize={10}
                tickFormatter={(v) => (v || '').replace(/^20/, '')} interval={2} />
        <YAxis stroke="#94A3B8" fontSize={11} width={60} />
        <Tooltip
          contentStyle={{ backgroundColor: '#0F1923', border: '1px solid #1E4E8C', borderRadius: 6 }}
          labelStyle={{ color: '#F1F5F9' }}
          formatter={(v) => `${Math.round(v).toLocaleString()} MHrs`}
        />
        <Legend wrapperStyle={{ fontSize: 11 }} />
        <Bar dataKey="engineeringMHrs" stackId="a" fill="#3B82F6" name="Engineering" />
        <Bar dataKey="procurementMHrs" stackId="a" fill="#10B981" name="Procurement" />
        <Bar dataKey="constructionMHrs" stackId="a" fill="#F59E0B" name="Construction" />
        <Bar dataKey="projectMgmtMHrs" stackId="a" fill="#6B7280" name="Project Mgmt" />
      </BarChart>
    </ResponsiveContainer>
  </div>
);

export default ResourceLoadingChart;
